// entrypoint.tsx

import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/uiAdminPagesFieldsQuery$parameters';

export const globalSettingsIssueFieldsManagementRouteEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-jira-admin-pages-fields-page" */ './src'),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			globalFields: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
				},
			},
		},
		extraProps: {},
	}),
});
